import styled from 'styled-components'
import { clickDown, clickUp } from '../../../../animations/Transitions'
import { colors, cyberColors } from '../../../../lib/colors'
import { ActionButtonStyledProps } from './interface'

export const ActionButtonWrapper = styled.div<ActionButtonStyledProps>`
  width: ${({ width }: any) => width || '150px'};
  span {
    line-height: 100%;
    transform: translateY(1px);
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ height }: any) => height || '24px'};
    width: ${({ width }: any) => width || '150px'};
    background: ${({ bg }: any) =>
      bg === 'red'
        ? cyberColors.redGradient
        : bg === 'blue'
        ? cyberColors.blueGradient
        : colors.primaryLight};
    color: ${colors.white};
    font-size: ${({ fontSize }: any) => fontSize || '12px'};
    margin: ${({ margin }: any) => margin || '0px'};
    border-radius: 4px;
    cursor: pointer;
    box-shadow: inset 0px -1.21px 0px ${({ bg }: any) => (bg === 'red' ? cyberColors.darkRed : bg === 'blue' ? cyberColors.darkBlue : 'transparent')};
    clip-path: inset(0px 0.5px);
    ${clickUp}
  }
  :active {
    .btn {
      ${clickDown}
    }
  }
`

export const ColFlexDiv = styled.div<ActionButtonStyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: ${({ margin }: any) => margin || '0px'};
`
